import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {DashboardListComponent} from './dashboard-list/dashboard-list.component';
import {DashboardForItComponent} from './dashboard-for-it/dashboard-for-it.component';


export const dashboardRoutes: Routes = [
  {
    path: 'dashboard',
    component: DashboardListComponent
  },
  {
    path: 'dashboard-it',
    component: DashboardForItComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(dashboardRoutes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule {
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/dashboard/dashboard-routing.module.ts